import { useState } from "react";
import { Box, Divider, Grid, Stack } from "@mui/material";
import ByzNurseSaveButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseSaveButton";
import ByzNurseDeleteButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseDeleteButton";
import ByzNursePrintButton2 from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNursePrintButton2";
import ByzMuiSnackBar from "src/components/core-components/mui/ByzMuiSnackBar";
import { useTranslate } from "src/locales";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import { ByzMuiDateTimePicker } from "src/components/core-components/mui/inputs/ByzMuiDateTimePicker";
import ByzSelectListPopupInput from "src/components/core-components/mui/inputs/ByzSelectListPopupInput";
import { useAppSelector } from "src/app/hooks";
//MUZUN;454081;07042025
function MedicalPanel() {
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [alertSeverity, setAlertSeverity] = useState<"error" | "success">(
        "success"
    );

    const showAlert = (message: string, severity: "error" | "success") => {
        setAlertMessage(message);
        setAlertSeverity(severity);
        setAlertOpen(true);
    };
    const handleSaveMedcard = async () => {
        try {
            const response = 'Medcard Kaydedildi';
            console.log("Save API cevabı:", response);
            showAlert(response, "success");
        } catch (error) {
            console.error("Hata:", error);
            showAlert("Medcard kaydedilirken hata oluştu!", "error");
        }
    };

    const handleDeleteMedcard = async () => {
        try {
            const response = 'Medcard Silindi';
            console.log("Delete API cevabı:", response);
            showAlert(response, "success");
        } catch (error) {
            console.error("Hata:", error);
            showAlert("Medcard silinirken hata oluştu!", "error");
        }
    };

    const { t } = useTranslate();
    const { user } = useAppSelector((state) => state.auth);

    return (
        <>
            <Stack
                sx={{ padding: "5px" }}
                mt={5}
                direction="row"
                spacing={2}
            >
                <ByzNurseSaveButton onClick={handleSaveMedcard} />
                <ByzNurseDeleteButton onClick={handleDeleteMedcard} />
                <ByzNursePrintButton2 />
            </Stack>
            <Divider sx={{ my: 2, borderColor: 'black', borderWidth: '1px' }} />
            <Box sx={{ width: "100%", p: 3 }}>
                <Grid container spacing={2}>
                    <Grid xs={12} md={4} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                        <Box
                            sx={{
                                backgroundColor: "rgb(231, 239, 252)",
                                height: "56px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "left",
                            }}
                        >
                            <ByzMuiTypography isTitle>
                                {t("adverse-effect-form.used-medical-products")}
                            </ByzMuiTypography>
                        </Box>
                    </Grid>
                    <Grid xs={12} md={8}>

                    </Grid>
                    <Grid xs={12} md={4} sx={{ borderBottom: "1px solid #E0E0E0", p: 2 }}>
                        <ByzMuiTypography>{t("adverse-effect-form.drug-type")}</ByzMuiTypography>
                    </Grid>
                    <Grid xs={12} md={8}>
                        <ByzMuiSelect
                            renderInput={(params) => (
                                <ByzMuiTextField {...params} label={t("buttons.chose")} variant="outlined" />
                            )}
                            options={[]}
                            sx={{ width: "100%", maxWidth: "300px" }}
                            color="info"
                            label="Select"
                            placeholder={t("buttons.chose")}
                        />
                    </Grid>

                    <Grid xs={12} md={4} sx={{ borderBottom: "1px solid #E0E0E0", p: 2 }}>
                        <ByzMuiTypography>{t("adverse-effect-form.method-of-usage")}</ByzMuiTypography>
                    </Grid>
                    <Grid xs={12} md={8}>
                        <ByzSelectListPopupInput
                            url="/nurse/v1/Nurse/GetNurseFloorPrivList/V1"
                            method="POST"
                            postData={{
                                useR_ID: user?.id,
                                hB_ID: 0,
                            }}
                            dialogTitle={t("adverse-effect-form.method-of-usage-list")}
                            displayField="NAME"
                            dialogShowOkButton={true}
                        />
                    </Grid>

                    <Grid xs={12} md={4} sx={{ borderBottom: "1px solid #E0E0E0", p: 2 }}>
                        <ByzMuiTypography>{t("adverse-effect-form.start-date")}</ByzMuiTypography>
                    </Grid>
                    <Grid xs={12} md={8}>
                        <ByzMuiDateTimePicker sx={{ width: "100%", maxWidth: "300px" }} />
                    </Grid>

                    <Grid xs={12} md={4} sx={{ borderBottom: "1px solid #E0E0E0", p: 2 }}>
                        <ByzMuiTypography>{t("adverse-effect-form.Indication")}</ByzMuiTypography>
                    </Grid>
                    <Grid xs={12} md={8}>
                        <ByzMuiTextField
                            label={t("adverse-effect-form.enter")}
                            variant="outlined"
                            sx={{ width: "100%", maxWidth: "300px" }}
                        />
                    </Grid>

                    <Grid xs={12} md={4} sx={{ borderBottom: "1px solid #E0E0E0", p: 2 }}>
                        <ByzMuiTypography>{t("adverse-effect-form.name-of-the-suspected-drug")}</ByzMuiTypography>
                    </Grid>
                    <Grid xs={12} md={8}>
                        <ByzSelectListPopupInput
                            url="/nurse/v1/Nurse/GetNurseFloorPrivList/V1"
                            method="POST"
                            postData={{
                                useR_ID: user?.id,
                                hB_ID: 0,
                            }}
                            dialogTitle={t("adverse-effect-form.drug-list")}
                            displayField="NAME"
                            dialogShowOkButton={true}
                        />

                    </Grid>

                    <Grid xs={12} md={4} sx={{ borderBottom: "1px solid #E0E0E0", p: 2 }}>
                        <ByzMuiTypography>{t("adverse-effect-form.daily-dose")}</ByzMuiTypography>
                    </Grid>
                    <Grid xs={12} md={8}>
                        <ByzMuiTextField
                            label={t("adverse-effect-form.enter")}
                            variant="outlined"
                            sx={{ width: "100%", maxWidth: "300px" }}
                        />
                    </Grid>

                    <Grid xs={12} md={4} sx={{ borderBottom: "1px solid #E0E0E0", p: 2 }}>
                        <ByzMuiTypography>{t("adverse-effect-form.end-date")}</ByzMuiTypography>
                    </Grid>
                    <Grid xs={12} md={8}>
                        <ByzMuiDateTimePicker sx={{ width: "100%", maxWidth: "300px" }} />
                    </Grid>

                    <Grid xs={12} md={4} sx={{ borderBottom: "1px solid #E0E0E0", p: 2 }}>
                        <ByzMuiTypography>{t("adverse-effect-form.nurse")}</ByzMuiTypography>
                    </Grid>
                    <Grid xs={12} md={8}>
                        <ByzMuiTextField
                            label={t("adverse-effect-form.enter")}
                            disabled
                            variant="outlined"
                            sx={{ width: "100%", maxWidth: "300px" }}
                        />
                    </Grid>
                </Grid>
            </Box>
            <ByzMuiSnackBar
                open={alertOpen}
                onClose={() => setAlertOpen(false)}
                title={
                    alertSeverity === "success"
                        ? t("operation-successful")
                        : t("error")
                }
                message={alertMessage}
                type={alertSeverity}
            />
        </>
    );
}

export default MedicalPanel;
